import * as _ from "../../../util/lodash";
import React from 'react';
import classnames from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { positions, sizes, font, textAlignments, widths, colors } from "../../../enums";
import Layout from "../../core/layout";
import ContentItem from "../content-item";
import Header from "../../core/header";
import { whitelistStyles } from "../../core/hoc";
var ListItem = createComponent({
  displayName: 'ListItem',
  propTypes: {
    image: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    topline: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    header: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    byline: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    meta: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    actions: PropTypes.element,
    actionsWidth: PropTypes.oneOf(widths.ALL),
    verticalAlign: PropTypes.oneOf(positions.verticalAlign.ALL),
    size: PropTypes.oneOf(_.without(sizes.ALL, sizes.X1)),
    isActive: PropTypes.bool
  },
  defaultProps: {
    image: undefined,
    topline: undefined,
    header: undefined,
    byline: undefined,
    meta: undefined,
    actions: undefined,
    actionsWidth: widths.THREE,
    verticalAlign: undefined,
    size: sizes.X6,
    isActive: false
  },
  render: function render(p) {
    var className = classnames('ck list-item', {
      active: p.isActive
    });
    var header = p.header;

    if (p.isActive) {
      header = /*#__PURE__*/React.isValidElement(header) ? /*#__PURE__*/React.cloneElement(header, {
        color: colors.ACCENT
      }) : /*#__PURE__*/React.createElement(Header, {
        text: header,
        color: colors.ACCENT
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(Layout, {
      style: p.style
    }, /*#__PURE__*/React.createElement(ContentItem, {
      image: p.image,
      topline: p.topline,
      header: header,
      byline: p.byline,
      meta: p.meta,
      verticalAlign: p.verticalAlign,
      size: p.size,
      font: {
        weight: font.weights.LIGHT,
        family: font.families.CUSTOM,
        emphasis: font.emphasis.NORMAL
      }
    }), p.actions ? /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: p.actionsWidth,
      textAlign: textAlignments.RIGHT,
      verticalAlign: positions.alignColumns.MIDDLE
    }, p.actions) : null));
  }
});
export default whitelistStyles()(ListItem);
//# sourceMappingURL=index.js.map